import React from 'react';

import PropTypes from 'prop-types';

import Spinner from '@/components/common/Spinner';
import OrderCard from '@/components/SchedulePage/OrderCard';
import SortSwitcher from '@/components/SchedulePage/Timeline/PendingOrders/SortSwitcher';
import { getGeocodableEntityId } from '@/services/geocodableAddressUtils';
import classes from '@/components/SchedulePage/Timeline/PendingOrders/style.module.scss';

const PendingOrdersComponent = ({
  pendingOrders,
  busy,
  error,
  orderRef,
  handleDragOver,
  handleDrop,
  intl,
  layout,
  selectedMapOrderId,
  unlocatedOrderIds,
  onMapOrderClick,
}) => (
  <div className={`${classes.pendingOrders} ${layout === 'map' ? classes.mapLayout : ''}`}>
    <SortSwitcher layout={layout} />

    {busy ? (
      <div className={classes.spinner}>
        <Spinner />
      </div>
    ) : error ? (
      <p>{intl.formatMessage({ id: 'ORDERS_LOAD_ERROR_MESSAGE' })}</p>
    ) : (
      <ul onDragOver={handleDragOver} onDrop={evt => handleDrop(evt)}>
        {pendingOrders.length ? (
          pendingOrders.map(order => {
            const orderId = String(getGeocodableEntityId(order));

            return (
              <li key={orderId} className="fade-in">
                <OrderCard
                  order={{ order, schedule: null }}
                  ref={orderRef}
                  isMapSelected={orderId === selectedMapOrderId}
                  onMapOrderClick={onMapOrderClick}
                />
              </li>
            );
          })
        ) : (
          <p>{intl.formatMessage({ id: 'NO_PENDING_ORDERS_MESSAGE' })}</p>
        )}
      </ul>
    )}
  </div>
);

PendingOrdersComponent.propTypes = {
  pendingOrders: PropTypes.array,
  busy: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  orderRef: PropTypes.object.isRequired,
  handleDragOver: PropTypes.func.isRequired,
  handleDrop: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  layout: PropTypes.oneOf(['timeline', 'map']),
  selectedMapOrderId: PropTypes.string,
  unlocatedOrderIds: PropTypes.arrayOf(PropTypes.string),
  onMapOrderClick: PropTypes.func,
};

PendingOrdersComponent.defaultProps = {
  pendingOrders: [],
  layout: 'timeline',
  selectedMapOrderId: null,
  unlocatedOrderIds: [],
  onMapOrderClick: undefined,
};

export default PendingOrdersComponent;
